import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorApi } from './api/transporte';
import { ProveedorAvisos } from './componentes/ui';
import { aplicarTema, leerTema } from './lib/tema';
import { ProveedorSesion } from './sesion';
import './estilos.css';

aplicarTema(leerTema());

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      // Errores 4xx no se reintentan (permiso, no encontrado…).
      retry: (n, e) => !(e instanceof ErrorApi && e.status >= 400 && e.status < 500) && n < 2,
    },
  },
});

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <ProveedorAvisos>
        <ProveedorSesion>
          <App />
        </ProveedorSesion>
      </ProveedorAvisos>
    </QueryClientProvider>
  </StrictMode>,
);
